import { http } from '../../config/axios'

export default function postRegistro(registro: any): Promise<string> {
  return http
    .post('api/registro', registro, {
      headers: {
          'originRegistro': 'web'
      }
  })
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro post registro', error)
      throw Error(error.response.data)
    })
}
